module.exports = __webpack_public_path__ + "static/media/dollar.b4c53d18.svg";